import React from "react";
import PropTypes from "prop-types";

const ENTER_KEY = 13;

export function IconBlock(props) {
  const onClick = (event) => props.onSelect(event);

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.onSelect(event);

  const style = { backgroundColor: props.color };

  return (
    <div
      role="button"
      onClick={onClick}
      style={style}
      onKeyDown={onKeyDown}
      className={props.className}
      tabIndex={props.tabIndex}
      aria-label={props.ariaLabel ? props.ariaLabel : null}
    >
      {props.children}
    </div>
  );
}

IconBlock.propTypes = {
  /**
   * tabIndex to set on Element
   */
  tabIndex: PropTypes.number,
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback for onClick event of icon
   */
  onSelect: PropTypes.func,
  /**
   * Step Color
   */
  color: PropTypes.string,
  /**
   * Child components to this component
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  ariaLabel: PropTypes.string,
};

IconBlock.defaultProps = {
  className: "",
};
